import { Pipe, PipeTransform } from '@angular/core'
import { ClinicService, FacilityService, Note } from '@mmx/shared'
import moment from 'moment-timezone'

@Pipe({
  name: 'noteText',
  standalone: false,
})
export class NoteTextPipe implements PipeTransform {

  constructor(
    private clinicService: ClinicService,
    private facilityService: FacilityService,
  ) {}

  transform(note: Note): string {
    const facility = this.facilityService.current$.value
    const tz = facility?.timezone || this.clinicService.clinic?.settings?.defaultTimezone || 'America/New_York'
    const date = moment.tz(note.createdAt, tz).format('M/D')
    const user = note.clinician?.abbreviation ? `  /${note.clinician.abbreviation}` : (
      note.autoGenerated ? '  /system' : ''
    )

    return `${date}  ${note.text.trim()}${user}`
  }
}
